export default __webpack_public_path__ + "static/icon-test-85fc24623e86cefda2fdfd42dcfd1b9f.svg";